(function() {

	class ComponentRegistryManager{

		constructor(){
			this.componentRegistry = new Map();
		}
		
		getComponentRegistry(){
			return this.componentRegistry;
		}
		
		/**
		 * Register a component instance to a specified identifier
		 */
		register(instance, instanceId){
			this.componentRegistry.set(instanceId, instance); //TODO align inverted names
		}
		
		deRegister(handle){
			this.componentRegistry.delete(handle);
		}
		
		getComponentInstance(handle){
			return this.componentRegistry.get(handle);
		}
	}

	window.ComponentRegistryManager = ComponentRegistryManager;
}());